module.exports = "//static.hsappstatic.net/livechat-unboxing-ui/static-1.7367/img/livechat-background.svg"